@if (contentlet$ | async; as contentlet) {
<div class="card-body">
  <div class="accordion-shadow">
    <div ngbAccordion [closeOthers]="true">
      <div ngbAccordionItem #item="ngbAccordionItem">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton type="button">
            <div class="accordion-header">
              <p
                ngbAccordionButton
                dotCmsSetAttributes
                [mode]="'full'"
                [fieldName]="'question'"
                [identifier]="contentlet.identifier"
                [innerHTML]="contentlet.question"
              ></p>
              <span class="faq-icon position-absolute">
                <i
                  [ngClass]="{
                    open: !isOpened(item),
                    close: isOpened(item)
                  }"
                ></i>
              </span>
            </div>
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div
                class="card-content"
                dotCmsSetAttributes
                [mode]="'full'"
                [fieldName]="'answer'"
                [identifier]="contentlet.identifier"
                [ishServerHtml]="contentlet.answer"
              ></div
            ></ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
